module.exports = __webpack_public_path__ + "static/Dispatch-Management-6ead1e3b7163acbdb9530adff4875294.jpg";